import './localization';
import options from './options';
import { RemotePhysics } from './physics-remote';
import { registerServiceWorker } from './registerServiceWorker';
import { Roulette } from './roulette';

registerServiceWorker();

const roulette = new Roulette();

(window as any).roulette = roulette;
(window as any).options = options;
// 방송 스트리밍에서 사용하는 훅
(window as any).MarbleBroadcast = {
  RemotePhysics,
  // 뷰어 모드 진입: physics를 원격 주입용으로 교체 + freeze
  enterViewerMode() {
    const r = roulette as any;
    const remote = new RemotePhysics();
    // 원래 physics로부터 stage 정보 복제(맵 뷰어 렌더용)
    if (r._stage) remote.createStage(r._stage);
    r.physics = remote;
    r.freezePhysics = true;
    (window as any).MarbleBroadcast._remote = remote;
  },
  exitViewerMode() {
    const r = roulette as any;
    r.freezePhysics = false;
    // Box2dPhysics 복원은 페이지 새로고침 권장 (Box2D 상태 복구 복잡)
  },
  applyFrame(frame: Array<{ id: number; x: number; y: number; a: number }>) {
    const remote = (window as any).MarbleBroadcast._remote as RemotePhysics | undefined;
    if (remote) remote.applyFrame(frame);
  },
  // 호스트에서 프레임 추출
  extractFrame(): Array<{ id: number; x: number; y: number; a: number }> {
    const marbles = roulette.marbles;
    const out = [];
    for (const m of marbles) {
      out.push({ id: m.id, x: m.x, y: m.y, a: m.angle });
    }
    return out;
  },
};
